import * as DIVISION_TYPES from './actionTypes';
import {
  IFetchDivisionListRequest,
  IFetchDivisionListSuccess,
  IFetchDivisionListFailure,
  IFetchDivisionListSuccessPayload,
  IClearDivisionList
} from './types';

export const fetchDivisionListRequest = ({
  countryId,
  successCb,
  failureCb
}: Omit<IFetchDivisionListRequest, 'type'>): IFetchDivisionListRequest => ({
  type: DIVISION_TYPES.FETCH_DIVISION_LIST_REQUEST,
  countryId,
  successCb,
  failureCb
});

export const fetchDivisionListSuccess = (payload: IFetchDivisionListSuccessPayload): IFetchDivisionListSuccess => ({
  type: DIVISION_TYPES.FETCH_DIVISION_LIST_SUCCESS,
  payload
});

export const fetchDivisionListFailure = (error: Error): IFetchDivisionListFailure => ({
  type: DIVISION_TYPES.FETCH_DIVISION_LIST_FAILURE,
  error
});

export const clearDivisionList = (): IClearDivisionList => ({
  type: DIVISION_TYPES.CLEAR_DIVISION_LIST
});
